import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=9bdd8bc8&"
import script from "./ProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bdd8bc8')) {
      api.createRecord('9bdd8bc8', component.options)
    } else {
      api.reload('9bdd8bc8', component.options)
    }
    module.hot.accept("./ProjectInfo.vue?vue&type=template&id=9bdd8bc8&", function () {
      api.rerender('9bdd8bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/projects/partials/ProjectInfo.vue"
export default component.exports